<template>
  <v-card class="card-wrap">
    <v-card-title>T-code distribution</v-card-title>
    <div class="box">
      <v-row class="h-100">
        <v-col cols="7">
          <tcode-bar :values="values" :colors="colors" area-style="linearGradient" />
        </v-col>
        <v-col cols="5">
          <tcode-pie :values="values" :colors="colors" area-style="linearGradient" />
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>

<script>
import { DEFAULT_COLORS } from '@/constants';
import TcodeBar from './TcodeBar.vue';
import TcodePie from './TcodePie.vue';

export default {
  components: {
    TcodeBar,
    TcodePie,
  },
  props: {
    points: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      labelList: ['0 ↓', '5K ↓', '1M ↓', '2M ↓', '2M ↑'],
    };
  },
  computed: {
    values() {
      return this.points.map((value, index) => {
        return { value: value, name: this.labelList[index] };
      });
    },
    colors() {
      return [DEFAULT_COLORS[9], DEFAULT_COLORS[3], DEFAULT_COLORS[2], DEFAULT_COLORS[1], DEFAULT_COLORS[8]];
    },
  },
};
</script>

<style></style>
